module.exports = __webpack_public_path__ + "static/img/fascist1.851bcd6.png";


//////////////////
// WEBPACK FOOTER
// ./src.common/assets/role/fascist1.png
// module id = 71
// module chunks = 0